import styled, { css, keyframes } from 'styled-components';
import { SpinnerPosition } from './types';

const translate = 'translate3d(0, -50%, 0)';
const translateCenter = 'translate3d(-50%, -50%, 0)';
const translateNone = 'translate3d(0, 0, 0)';

const spin = keyframes`
    0% {
      transform: rotate(0) ${translate};
    }
    100% {
      transform: rotate(360deg) ${translate};
    }
  `;

const spinCenter = keyframes`
    0% {
      transform: rotate(0) ${translateCenter};
    }
    100% {
      transform: rotate(360deg) ${translateCenter};
    }
  `;

const spinNone = keyframes`
    0% {
      transform: rotate(0) ${translateNone};
    }
    100% {
      transform: rotate(360deg) ${translateNone};
    }
  `;
interface Props {
  position: SpinnerPosition;
}

export const StyledSpinner = styled.span<Props>`
  border-radius: 50%;
  display: block;
  border: solid rgba(0, 0, 0, 0.2);
  border-top-color: ${p => p.theme.colors.base0};
  position: absolute;
  top: 50%;
  ${p =>
    (p.position === 'left' || p.position === 'right') &&
    css`
      transform-origin: 50% 0;
      animation: ${spin} 0.6s infinite linear;
    `}
  ${p =>
    p.position === 'left' &&
    css`
      left: 10px;
    `}

  ${p =>
    p.position === 'right' &&
    css`
      right: 10px;
    `}

  ${p =>
    p.position === 'center' &&
    css`
      left: 50%;
      transform-origin: 0 0;
      animation: ${spinCenter} 0.6s infinite linear;
    `}

  ${p =>
    p.position === 'none' &&
    css`
      animation: ${spinNone} 0.6s infinite linear;
      position: relative;
      left: 0;
      top: 0;
    `}
`;
